// extracted by mini-css-extract-plugin
module.exports = {"boxDropdown":"_2XhFDKLWFG18qNq_8VPJEr","content":"_2kJGDTiW2JKGYtnAzsZxB5","dropdown":"_3RqNOl2hPkEhdSYHlQHtdk"};